import { Theme, styled } from "@mui/material/styles";

/* eslint-disable quote-props */
export const cardStyle = () => ({
  borderRadius: "8px",
  boxShadow: "none",
  width: "100%",
  maxHeight: "281px",
});

export const cardStyleActive = (theme: Theme) => ({
  boxShadow: "none",
  width: "100%",
  maxHeight: "281px",
  borderWidth: "2px",
  borderStyle: "solid",
  borderColor: theme.palette.primary.main,
  backgroundColor: theme.palette.warning.main,
});

export const boxIconContainer = (theme: Theme) => ({
  display: "inline-block",
});

export const Image = styled("img")({
  objectFit: "cover",
  height: "100%",
  width: "100%",
});

export const ImgOverlay = styled("div")({
  position: "absolute",
  zIndex: "2",
  background: "rgba(36, 36, 36, 0.16)",
  width: "100%",
  height: "100%",
  cursor: "pointer",
  transition: "all 6s ease",
});
